var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99988 12.8599C7.59988 12.8599 5.63988 10.8999 5.63988 8.4999C5.63988 6.0999 7.59988 4.1399 9.99988 4.1399C12.3999 4.1399 14.3599 6.0999 14.3599 8.4999C14.3599 10.8999 12.3999 12.8599 9.99988 12.8599ZM9.99988 2.8799C6.89988 2.8799 4.37988 5.3999 4.37988 8.4999C4.37988 11.5999 6.89988 14.1199 9.99988 14.1199C13.0999 14.1199 15.6199 11.5999 15.6199 8.4999C15.6199 5.3999 13.0999 2.8799 9.99988 2.8799Z",
    fill: "#FFC72C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.08 16C9.5 14.13 4.7 15.71 3.92 16C2.39 14.45 1.45 12.34 1.45 10C1.45 5.29 5.29 1.45 10 1.45C14.71 1.45 18.55 5.29 18.55 10C18.55 12.34 17.61 14.45 16.08 16ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.519 20 20 15.52 20 10C20 4.48 15.519 0 10 0Z",
    fill: "#FFC72C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.4305cb81eac2b6c8cd32d9f593a9dc28.svg";
export { ForwardRef as ReactComponent };